import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../hooks/useIsMobile";
import { AuthedImage } from "../ui/AuthedImage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faImage, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

interface FilePlaceHolderProps {
    imageSrc: string | null;
    imageAltText?: string;
    imageStyle?: React.CSSProperties;
    placeholderStyles?: React.CSSProperties;
    placeholderIcon?: IconDefinition;
    placeholderText?: string;
    donwloadTitle?: string;
    onDownload?: () => void;
    onDropImage?: (file:File) => void;
}

export const FilePlaceHolderWithDragAndDrop = ({
    imageSrc,
    imageAltText,
    imageStyle,
    donwloadTitle,
    placeholderStyles,
    placeholderIcon,
    placeholderText,
    onDownload,
    onDropImage
}:FilePlaceHolderProps) => {
    const isMobile = useIsMobile();
    const { t } = useTranslation('generation');
    const [imageDragActive, setImageDragActive] = useState(false);
    return (
        <>
            { imageSrc 
                ?   <>
                        <AuthedImage
                            src={imageSrc}
                            alt={imageAltText ?? t('lastGeneratedImage')}
                            className="border border-secondary rounded d-block"
                            style={{
                                ...imageStyle,
                                maxWidth: "100%",
                                maxHeight: isMobile ? "350px" : "100%",
                                width: "auto",
                                height: "auto",
                                objectFit: "contain"
                            }}
                        />
                        { onDownload && (
                            <button
                                type="button"
                                className="btn btn-outline-secondary mt-0 position-absolute top-0 end-0 m-2 border border-secondary rounded"
                                title={donwloadTitle ?? t("download.image")}
                                onClick={onDownload}
                                style={{ zIndex: 2 }}
                            >
                                <FontAwesomeIcon
                                    icon={faDownload}
                                    size="xl"
                                    className="bg-transparent me-2"
                                />
                            </button>
                            )
                        }
                    </>
                :   <div
                        className={`text-center border rounded mt-2 d-flex flex-column align-items-center justify-content-center ${imageDragActive &&onDropImage ? "border-purple" : "border-secondary border-opacity-25"} ${isMobile ? 'h4' : 'h3'}`}
                        style={{
                            ...placeholderStyles,
                            width: isMobile ? "180px" : "100%",
                            height: isMobile ? "180px" : "100%",
                            minHeight: isMobile ? "180px" : "250px"
                        }}
                        onDragEnter={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setImageDragActive(true);
                        }}
                        onDragOver={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setImageDragActive(true);
                        }}
                        onDragLeave={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setImageDragActive(false);
                        }}
                        onDrop={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setImageDragActive(false);

                            const file = e.dataTransfer.files?.[0];
                            if (!file) return;

                            onDropImage?.(file);
                        }}
                    >
                        <p className="m-0 p-0 opacity-25 ">
                            <FontAwesomeIcon
                                icon={placeholderIcon ?? faImage}
                                size={isMobile ? '1x' : "2xl"}
                                className="me-2"
                            />
                            {placeholderText ?? t('noGeneratedImage')}
                        </p>
                </div>
                
            }
        </>
    )
};